import { ServiceStateEnum } from '@mwe/constants';
import { Product } from './product.model';

export interface BillInfoGroupData {
  product: Product;
  billinfo?: IProductBillinfo;
  detailsState: ServiceStateEnum;
  isBillInfoAvailable: boolean;
}

export interface IBillinfoDetail {
  detailType: string; // BLART
  amount: string; // AMOUNT Betrag
  description: string; // TEXT Belegtext
  bookingDate: Date; // BUDAT Buchungsdatum
  dueDate: Date; // FAEDN Fälligkeitsdatum
  cdFlag: string; // creditDebitFlag
}

export interface IProductBillinfo {
  accountNumber: string; // vertragsKontoNummer
  category: string; // sparte
  amount: string;
  amountKind: string;
  groupLevel: string;
  currency: string;
  cdFlag: string;
  details: IBillinfoDetail[];
}

export interface IBillinfoSum {
  accountNumber: string; // vertragsKontoNummer
  category: string; // sparte
  amount: string; // AMOUNT Betrag
  amountKind: string;
  cdFlag: string; // creditDebitFlag
}

export interface IProductBillinfoOverview {
  details: Map<string, IBillinfoSum>;
}

// Pure function to get category key
export const getCategoryKey = (category: string): string => {
  return `products.category.${category.toLowerCase()}`;
};

// Pure functions for ProductBillinfoOverview
export const getAmountFor = (overview: IProductBillinfoOverview, amountKind: string, defaultValue: string): string => {
  return overview.details.has(amountKind) ? overview.details.get(amountKind).amount : defaultValue;
};

export const getCreditDebitFor = (overview: IProductBillinfoOverview, amountKind: string): string => {
  return overview.details.has(amountKind) ? overview.details.get(amountKind).cdFlag : '';
};

// Parse ProductBillinfoOverview from JSON
export const parseProductBillinfoOverview = (json: any = {}): IProductBillinfoOverview => {
  const details = new Map<string, IBillinfoSum>();
  if (json.kostenUebersicht?.length > 0) {
    json.kostenUebersicht.forEach((item: any) => {
      const sum: IBillinfoSum = {
        accountNumber: item.vertragskontoId,
        category: item.sparte,
        amount: item.amount,
        amountKind: item.amountKind,
        cdFlag: item.creditDebit,
      };
      details.set(sum.amountKind, sum);
    });
  }
  return { details };
};

// Parse ProductBillinfo from JSON
export const parseProductBillinfo = (json: any = {}): IProductBillinfo | null => {
  if (!json.kostenDetails?.length) return null;

  let result: IProductBillinfo | null = null;
  const biDetails: IBillinfoDetail[] = [];

  json.kostenDetails.forEach((detail: any) => {
    if (detail.amountKind !== '04') return;
    if (detail.groupLevel === '01' || detail.groupLevel === '02') {
      result = {
        accountNumber: detail.vertragskontoId,
        category: detail.sparte,
        amount: detail.amount,
        amountKind: detail.amountKind,
        groupLevel: detail.groupLevel,
        currency: detail.currency,
        cdFlag: detail.creditDebit,
        details: biDetails,
      };
    }
    detail.itemDetails?.forEach((item: any) => {
      biDetails.push({
        detailType: item.blart,
        amount: item.amount,
        description: item.text,
        bookingDate: new Date(item.budat),
        dueDate: new Date(item.faedn),
        cdFlag: item.creditDebitFlag,
      });
    });
  });

  return result;
};
